import { css } from 'lit';
import { IxSelect } from './IxSelect.js';

export class IxSelectStyled extends IxSelect {
  static override styles = css`
    :host([disabled]) {
      pointer-events: none;
    }
    :host([error]) {
      --md-outlined-select-text-field-outline-width: 2px;
    }
    .select {
      display: block;
    }
    ix-icon {
      height: var(--ix-select-leading-icon-height, 1.5rem);
      color: var(
        --ix-select-leading-icon-color,
        var(--clr-graphics-fill, #09224199)
      );
      margin-inline-start: var(--ix-select-leading-icon-inset);
    }
  `;
}

window.customElements.define('ix-select', IxSelectStyled);
